"use client"
import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import {Speed, Sequence, Wrapper} from "react-type-animation/dist/cjs/components/TypeAnimation/index.types";

type TypeAnimatorProps = {
    phrases: string[];
    timeBetween?: number;
    timeDelay?: Speed;
    wrapper?: Wrapper;
    className?: string;
    repeat?: number | typeof Infinity; // number of times to repeat
};

const TypeAnimator = ({
                          phrases,
                          timeBetween = 2000,
                          timeDelay = 40,
                          wrapper = 'h4',
                          repeat = Infinity,
                          className = 'inline-block bg-black text-white px-4 py-2 rounded-md',
                      }: TypeAnimatorProps) => {

    // Build the sequence array: [phrase1, timeBetween, phrase2, timeBetween, ...]
    const sequence: Sequence = [];
    phrases.forEach((phrase) => {
        sequence.push(phrase, timeBetween);
    });

    return (
        <TypeAnimation
            sequence={sequence}
            wrapper={wrapper}
            speed={timeDelay}
            className={className}
            repeat={repeat}
        />
    );
};

export default TypeAnimator;
